<span mat-dialog-title class="ace-heading-text-level-1">Confirm Tax Exemption</span>
<mat-dialog-content class="mat-typography" style="margin-top:40px;">
  <span class="ace-heading-text-tabs-level-2">Click continue to remove taxes from this revenue line item.</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
